import { render, staticRenderFns } from "./ModalEventUpdate.vue?vue&type=template&id=0f8b8196&scoped=true"
import script from "./ModalEventUpdate.vue?vue&type=script&lang=js"
export * from "./ModalEventUpdate.vue?vue&type=script&lang=js"
import style0 from "./ModalEventUpdate.vue?vue&type=style&index=0&id=0f8b8196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b8196",
  null
  
)

export default component.exports